module.exports = __webpack_public_path__ + "img/img4.d0161d3d.jpg";